import TodayIcon from "@mui/icons-material/Today";
import {
  Button,
  Fade,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography/Typography";
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from "@react-pdf/renderer";
import clsx from "clsx";
import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { getNotification } from "../../../../actions/notification";
import logo247UpTime from "../../../../assets/my247.PNG";
import IconText from "../../../../components/IconText";
import NotificationCardItem from "../../../../components/NotificationCardItem";
import { Theme247 } from "../../../../styles/Theme247";
import {
  NotificationType,
  StatusType,
  getNotificationTooltipAndColor,
} from "../../../../types";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { EmptyState } from "../../EmptyStat";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { setItem } from "../../../../utils/DataProtection";

var time = require("time-since");
var adjust_year = "";
export default connect(({ profile,machines }) => ({ profile,machines }), { getNotification })(
  (props) => {
    const i18n = useStore().getState().i18n;
    const store = useStore().getState();
    const eq = useStore().getState().machines.equipment;
    const [equipment, setequipment] = useState();

    useEffect(() => {
      setequipment(eq);
    }, []);
    const getCurrentDate = (separator = "") => {
      let newDate = new Date();
      let date = newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();

      return `${date}${separator}${
        month < 10 ? `0${month}` : `${month}`
      }${separator}${year}`;
    };
    const getCurrentYear = () => {
      let newDate = new Date();
      let year = newDate.getFullYear();

      return `${year}`;
    };

    const getYearFromTS = (timestamp) => {
      let d = new Date(timestamp);
      return d.getFullYear();
    };

    /*
     * Styles
     */
    const useStyles = makeStyles()(() => ({
      innerSectionContainerWrapper: {
        display: "flex",
        flexDirection: "column",
      },
      statsContainer: {
        padding: "38px 0",
      },
      timelineWrapper: {
        position: "relative",
      },
      sectionHeading: {
        marginBottom: 20,
      },
      itemcardList: {
        zIndex: 10,
        position: "relative",
      },
      historyHeaderFirstItem: {
        width: "100%",
        display: "flex",
        marginBottom: 60,
        justifyContent: "center",
        alignItems: "center",
      },
      historyFooterLastItem: {
        width: "100%",
        display: "flex",
        marginTop: 60,
        marginBottom: 28,
        justifyContent: "center",
        alignItems: "center",
      },
      timelineLineContainer: {
        position: "absolute",
        height: "calc(100% - 100px)",
        width: 2,
        left: "50%",
        top: 72,
      },
      timelineLine: {
        position: "absolute",
        flexDirection: "column" /* vertical line */,
        height: "100%",
        width: 2,
        left: 0,
        top: 0,
        bottom: 0,
        marginTop: 0,
        marginBottom: 0,
        zIndex: 1,
        border: "none",
        borderRight: "2px dashed " + Theme247.palette.grayShade["300"],
      },
      timelineBubble: {
        position: "absolute",
        borderWidth: 2,
        backgroundColor: Theme247.palette.white.main,
        borderStyle: "solid",
        borderColor: Theme247.palette.grayShade["300"],
        borderRadius: 100,
        width: 16,
        height: 16,
        left: -7,
        aspectRatio: 1,
        zIndex: 2,
      },
      timelineBubbleStart: {
        top: 0,
      },
      timelineBubbleEnd: {
        bottom: 0,
      },
      emptyStateText: {
        textAlign: "center",
      },
    }));
    const { classes, cx } = useStyles();

    function handleNotificationClick(item) {
      const notificationnodeid = item?.notification?.nodeid;
      props.getNotification(
        { nodeid: notificationnodeid },
        "GETSINGLENOTIFICATION",
      );
      setItem("notification-nodeid", item?.notification?.nodeid);
      setItem(
        "chatroomnodeid",
        item?.notification?.haschatroom?.[0].chatroom?.nodeid,
      );
    }

    const toggleFilter = () => {
      setIsFilter(!isFilter);
    };

    const [isFilter, setIsFilter] = useState(false);
    const [createdDate, setCreatedDate] = useState("YYYY-MM-DD");
    const [closedDate, setClosedDate] = useState("YYYY-MM-DD");
    const [typeValue, setTypeValue] = useState();
    const [statusValue, setStatusValue] = useState();
    const [keywordValue, setKeywordValue] = useState("");

    const [isTypeFilterEnabled, setIsTypeFilterEnabled] = useState(false);
    const [isStatusFilterEnabled, setIsStatusFilterEnabled] = useState(false);
    const [isKeywordFilterEnabled, setIsKeywordFilterEnabled] = useState(false);
    const [isCreatedFilterEnabled, setIsCreatedFilterEnabled] = useState(false);
    const [isClosedFilterEnabled, setIsClosedFilterEnabled] = useState(false);

    useEffect(() => {
      let result = eq;
      result = isCreatedFilterEnabled ? filterByCreatedDate(result) : result;
      result = isClosedFilterEnabled ? filterByClosedDate(result) : result;
      result = isTypeFilterEnabled ? filterByType(result) : result;
      result = isStatusFilterEnabled ? filterByStatus(result) : result;
      result = isKeywordFilterEnabled ? filterByKeyword(result) : result;
      isFilter && setequipment(result);
    }, [
      closedDate,
      createdDate,
      typeValue,
      statusValue,
      keywordValue,
      isTypeFilterEnabled,
      isStatusFilterEnabled,
      isKeywordFilterEnabled,
      isCreatedFilterEnabled,
      isClosedFilterEnabled,
    ]);

    const equp_local = props.machines?.equipment;

    let equq_pool_local;
    if (
      props.machines?.equipment?.isequipmentof &&
      props.machines?.equipment?.isequipmentof[0]?.equipmentpool !== undefined
    ) {
      equq_pool_local =
        props.machines?.equipment?.isequipmentof &&
        props.machines?.equipment?.isequipmentof[0].equipmentpool;
    } else {
      equq_pool_local =
        props.machines?.equipment?.isequipmentof &&
        props.machines?.equipment?.isequipmentof[0].area;
    }

    const filterByType = (array) => {
      const res = array?.hasnotification.filter((noti) => {
        return noti.notification.type === parseInt(typeValue);
      });
      let org_eq = array;
      const myData = {
        ...org_eq,
        hasnotification: res,
      };
      return myData;
    };

    const filterByStatus = (array) => {
      const res = array?.hasnotification.filter((noti) => {
        return noti.notification.status === parseInt(statusValue);
      });
      let org_eq = array;
      const myData = {
        ...org_eq,
        hasnotification: res,
      };
      return myData;
    };

    const filterByKeyword = (array) => {
      const res = array?.hasnotification.filter((noti) => {
        return noti.notification.title.includes(keywordValue);
      });
      let org_eq = array;
      const myData = {
        ...org_eq,
        hasnotification: res,
      };
      return myData;
    };

    const filterByCreatedDate = (array) => {
      const date = moment(new Date(createdDate)).format("YYYY-MM-DD");
      const res = array?.hasnotification.filter((noti) => {
        let format_date = moment(noti.notification.created).format(
          "YYYY-MM-DD",
        );
        return format_date >= date;
      });
      let org_eq = array;
      const myData = {
        ...org_eq,
        hasnotification: res,
      };
      return myData;
    };

    const filterByClosedDate = (array) => {
      const date = moment(new Date(closedDate)).format("YYYY-MM-DD");
      const res = array?.hasnotification.filter((noti) => {
        let format_date = moment(noti.notification.closed).format("YYYY-MM-DD");
        //console.log(format_date,"ended at");
        return noti.notification.closed === 0 ? {} : format_date <= date;
      });
      let org_eq = array;
      const myData = {
        ...org_eq,
        hasnotification: res,
      };
      return myData;
    };

    const handleCreatedDateChange = (e) => {
      setCreatedDate(e.target.value);
      if (e.target.value !== "YYYY-MM-DD") {
        setIsCreatedFilterEnabled(true);
      }
    };

    const handleClosedDateChange = (e) => {
      setClosedDate(e.target.value);
      if (e.target.value !== "YYYY-MM-DD") {
        setIsClosedFilterEnabled(true);
      }
    };

    const handleTypeChange = (e) => {
      if (e.target.value === "--- Select ---") {
        setIsTypeFilterEnabled(false);
      } else {
        setIsTypeFilterEnabled(true);
      }
      setTypeValue(e.target.value);
    };

    const handleStatusChange = (e) => {
      if (e.target.value === "--- Select ---") {
        setIsStatusFilterEnabled(false);
      } else {
        setIsStatusFilterEnabled(true);
      }
      setStatusValue(e.target.value);
    };

    const handleKeywordChange = (e) => {
      if (e.target.value === "") {
        setIsKeywordFilterEnabled(false);
      } else {
        setIsKeywordFilterEnabled(true);
      }
      setKeywordValue(e.target.value);
    };

    const handleResetFilter = () => {
      // setIsFilter(false);
      setStatusValue("--- Select ---");
      setTypeValue("--- Select ---");
      setKeywordValue("");
      setCreatedDate("0000-00-00");
      setClosedDate("0000-00-00");
      setequipment(eq);
    };

    Font.register({
      family: "Oswald",
      src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
    });

    const pdf_styles = StyleSheet.create({
      dashedLine: {
        width: "100%",
        height: "1px",
        border: "1px solid black",
        borderStyle: "dashed",
        marginTop: "25px",
      },
      normalFont: {
        fontSize: "10px",
      },
      rowMain: {
        flexDirection: "row",
        flexGrow: 1,
        justifyContent: "space-between",
        fontSize: "10px",
        marginTop: 5,
        width: "100%",
      },
      body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
      },
      title: {
        fontSize: 14,
      },
      italic: {
        fontStyle: "italic",
      },
      author: {
        fontSize: 12,
        textAlign: "center",
        marginBottom: 40,
      },
      subtitle: {
        fontSize: 18,
        margin: 12,
        fontFamily: "Oswald",
      },
      text: {
        margin: 12,
        fontSize: 14,
        textAlign: "justify",
        fontFamily: "Times-Roman",
      },
      image: {
        marginVertical: 15,
        marginHorizontal: 100,
      },
      header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: "center",
        color: "grey",
      },
      pageNumber: {
        position: "absolute",
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
        color: "grey",
      },
      logo: {
        width: "110px",
        height: "30px",
      },
      section45: {
        width: "45%",
      },
      section10: {
        width: "10%",
      },
      mainImages: {
        width: "45%",
        flexDirection: "row",
        flexGrow: 1,
      },
    });

    const MyDoc = () => (
      <Document>
        <Page style={pdf_styles.body}>
          <View>
            <View style={pdf_styles.rowMain}>
              <View>
                <Text style={{ marginTop: "2px" }}>
                  Report erstellt am {moment(new Date()).format("DD.MM.YYYY")}
                </Text>
              </View>
              <View>
                <Image src={logo247UpTime} style={pdf_styles.logo} />
              </View>
            </View>

            {/* <View style={{ margin: '3% 0%', fontSize: '10px' }}>
            <Text>ABC Gmbh</Text>
            <Text>Abc-Str. 1-5</Text>
            <Text>12345 Musterhausen</Text>
            <Text>Deutschland</Text>

          </View> */}
            <View style={{ margin: "20px 0px" }}></View>

            <View style={pdf_styles.rowMain}>
              <View style={pdf_styles.section45}>
                <Text style={pdf_styles.title}>
                  {" "}
                  {equipment?.name} ({equipment.equipmentid}){" "}
                </Text>
                <Text style={pdf_styles.title}>
                  {
                    equipment?.hasequipmenttype[0]?.equipmenttype
                      ?.isequipmenttypeof[0]?.brand?.name
                  }{" "}
                  {equipment?.hasequipmenttype[0]?.equipmenttype?.model}{" "}
                </Text>
                <Text style={pdf_styles.italic}> (serialNo) </Text>
                <Text>
                  {" "}
                  {equipment.isequipmentof[0]?.equipmentpool?.name}{" "}
                  {equipment.isequipmentof[1]?.area?.name}{" "}
                </Text>
              </View>
              <View style={pdf_styles.section10}></View>
              <View style={pdf_styles.mainImages}>
                {equipment?.typenameplate?.url && (
                  <Image
                    src={equipment?.typenameplate?.url}
                    style={{ width: "100%", marginRight: "7px" }}
                  />
                )}
                {equipment?.image?.url && (
                  <Image src={equipment.image.url} style={{ width: "100%" }} />
                )}
              </View>
            </View>

            <View>
              <Text style={{ margin: "4% 0% 0% 0%", fontSize: "14px" }}>
                {" "}
                Meldungen vom{" "}
                {moment(createdDate).isValid()
                  ? moment(createdDate).format("DD.MM.YYYY")
                  : ""}{" "}
                bis{" "}
                {moment(closedDate).isValid()
                  ? moment(closedDate).format("DD.MM.YYYY")
                  : ""}
              </Text>
            </View>

            {equipment.hasnotification.map((noti, key) => (
              <View key={key}>
                <View style={pdf_styles.dashedLine}></View>
                <Text style={{ fontSize: "10px", margin: "1% 0% 3% 0%" }}>
                  {"Routine Wartung's " +
                    moment(noti.notification.created).format("DD.MM.YYYY")}
                </Text>
                <Text style={pdf_styles.title}>{noti.notification.title}</Text>
                <Text style={pdf_styles.normalFont}>
                  Status: {StatusType(noti.notification.status)}
                </Text>
                <Text style={pdf_styles.normalFont}>Gemeldet durch: {}</Text>

                <Text style={{ fontSize: "10px", margin: "2% 0%" }}>
                  {noti.notification.description}
                </Text>

                <View style={{ fontSize: "10px", margin: "2% 0%" }}>
                  <Text>Anhange:</Text>
                  <Text>
                    {equipment?.hasattachment
                      ? equipment.hasattachment.length
                      : 0}{" "}
                    Attachments
                  </Text>
                </View>
              </View>
            ))}
          </View>

          <Text
            style={pdf_styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </Page>
      </Document>
    );

    const handleExportClick = async () => {
      const blob = await pdf(<MyDoc />).toBlob();
      saveAs(blob, "Equipment Report");
    };

    const myClasses = {
      sectionContentContainer: _s(Theme247.sectionContentContainer),
      innerSectionContainer: _s(Theme247.innerSectionContainer),
      nmb: _s(Theme247.noMargin.bottom),
      sectionOptionsButton: _s(Theme247.sectionOptionsButton),
      tsc: _s(Theme247.typography.small_caption),
      itemcardList: _s(Theme247.itemcardList),
      sectionHeader: _s(Theme247.sectionHeader),
    };

    return (
      <div>
        {equipment?.hasnotification?.length > 0 ||
        isCreatedFilterEnabled ||
        isTypeFilterEnabled ||
        isStatusFilterEnabled ||
        isKeywordFilterEnabled ||
        isClosedFilterEnabled ? (
          <>
            <Grid container justifyContent="center" spacing="0">
              <Grid item xs={12} className={myClasses.sectionContentContainer}>
                <div className="MO_maintenance">
                  <div
                    className={myClasses.sectionHeader}
                    style={{ margin: 0 }}
                  >
                    <Typography variant="h1">{i18n.history_title}</Typography>
                  </div>

                  <div className="HT" onClick={toggleFilter}>
                    <div className="preMailButton">
                      <div className="icon">
                        {isFilter ? (
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_3158_5520"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="18"
                            >
                              <rect width="18" height="18" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_3158_5520)">
                              <path
                                d="M9.00059 10.0496L5.32559 13.7246C5.18809 13.8621 5.01309 13.9309 4.80059 13.9309C4.58809 13.9309 4.41309 13.8621 4.27559 13.7246C4.13809 13.5871 4.06934 13.4121 4.06934 13.1996C4.06934 12.9871 4.13809 12.8121 4.27559 12.6746L7.95059 8.99961L4.27559 5.32461C4.13809 5.18711 4.06934 5.01211 4.06934 4.79961C4.06934 4.58711 4.13809 4.41211 4.27559 4.27461C4.41309 4.13711 4.58809 4.06836 4.80059 4.06836C5.01309 4.06836 5.18809 4.13711 5.32559 4.27461L9.00059 7.94961L12.6756 4.27461C12.8131 4.13711 12.9881 4.06836 13.2006 4.06836C13.4131 4.06836 13.5881 4.13711 13.7256 4.27461C13.8631 4.41211 13.9318 4.58711 13.9318 4.79961C13.9318 5.01211 13.8631 5.18711 13.7256 5.32461L10.0506 8.99961L13.7256 12.6746C13.8631 12.8121 13.9318 12.9871 13.9318 13.1996C13.9318 13.4121 13.8631 13.5871 13.7256 13.7246C13.5881 13.8621 13.4131 13.9309 13.2006 13.9309C12.9881 13.9309 12.8131 13.8621 12.6756 13.7246L9.00059 10.0496Z"
                                fill="#0E3F51"
                              />
                            </g>
                          </svg>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="text">Filter & Export</div>
                    </div>
                  </div>
                </div>
                <div className="MO_maintenance_desc">
                  {i18n.history_description}
                </div>
              </Grid>
            </Grid>

            <Grid container spacing="0" padding={0}>
              <Grid
                item
                xs={12}
                className={myClasses.sectionContentContainer}
                justifyContent="right"
                display={"flex"}
                padding={0}
              >
                <Link
                  to="/edit-notification"
                  state={{
                    notification: "",
                    equip: equp_local,
                    equip_pool: equq_pool_local,
                    date: "",
                    time: "",
                    pageType: "add",
                    from: "history",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "200px" }}
                  >
                    {i18n.new_issue}
                  </Button>
                </Link>
              </Grid>
            </Grid>

            {isFilter ? (
              <Fade in={isFilter}>
                <div className="history-filters">
                  <div className="row1">
                    <div className="child">
                      <FormControl
                        sx={{ margin: 0 }}
                        variant="standard"
                        fullWidth
                      >
                        <InputLabel htmlFor="standard-adornment-password">
                          {i18n.history_filter_keyword}
                        </InputLabel>
                        <Input
                          id="standard-adornment-password"
                          type={"text"}
                          value={keywordValue}
                          onChange={handleKeywordChange}
                          endAdornment={
                            <InputAdornment position="end">
                              <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_3158_5366"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="25"
                                  height="24"
                                >
                                  <rect
                                    x="0.75"
                                    width="24"
                                    height="24"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_3158_5366)">
                                  <path
                                    d="M19.65 20.3L14.05 14.7C13.55 15.1 12.975 15.4167 12.325 15.65C11.675 15.8833 10.9833 16 10.25 16C8.43333 16 6.896 15.371 5.638 14.113C4.37933 12.8543 3.75 11.3167 3.75 9.5C3.75 7.68333 4.37933 6.14567 5.638 4.887C6.896 3.629 8.43333 3 10.25 3C12.0667 3 13.6043 3.629 14.863 4.887C16.121 6.14567 16.75 7.68333 16.75 9.5C16.75 10.2333 16.6333 10.925 16.4 11.575C16.1667 12.225 15.85 12.8 15.45 13.3L21.075 18.925C21.2583 19.1083 21.35 19.3333 21.35 19.6C21.35 19.8667 21.25 20.1 21.05 20.3C20.8667 20.4833 20.6333 20.575 20.35 20.575C20.0667 20.575 19.8333 20.4833 19.65 20.3ZM10.25 14C11.5 14 12.5627 13.5627 13.438 12.688C14.3127 11.8127 14.75 10.75 14.75 9.5C14.75 8.25 14.3127 7.18733 13.438 6.312C12.5627 5.43733 11.5 5 10.25 5C9 5 7.93733 5.43733 7.062 6.312C6.18733 7.18733 5.75 8.25 5.75 9.5C5.75 10.75 6.18733 11.8127 7.062 12.688C7.93733 13.5627 9 14 10.25 14Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </g>
                              </svg>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>

                    <div className="child">
                      <FormControl
                        variant="standard"
                        sx={{ margin: 0 }}
                        fullWidth
                      >
                        <InputLabel id={"filter_type"}>
                          {i18n.history_filter_type}
                        </InputLabel>
                        <Select
                          labelId={"filter_type"}
                          id={"filter_type"}
                          label={i18n.history_filter_type}
                          value={typeValue}
                          onChange={handleTypeChange}
                        >
                          <MenuItem value="--- Select ---">
                            <em>---Select---</em>
                          </MenuItem>
                          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                            (noti, key) => {
                              return (
                                <MenuItem
                                  key={key}
                                  value={noti}
                                  style={{
                                    color: getNotificationTooltipAndColor(key)
                                      .color,
                                    display:
                                      key === 3 || key === 4 || key === 5
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  {getNotificationTooltipAndColor(key).tooltip}
                                </MenuItem>
                              );
                            },
                          )}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="child">
                      <FormControl
                        variant="standard"
                        sx={{ margin: 0 }}
                        fullWidth
                      >
                        <InputLabel id={"filter_status"}>
                          {i18n.history_filter_status}
                        </InputLabel>
                        <Select
                          labelId={"filter_status"}
                          id={"filter_status"}
                          label={i18n.history_filter_status}
                          value={statusValue}
                          onChange={handleStatusChange}
                        >
                          <MenuItem value="--- Select ---">
                            <em>---Select---</em>
                          </MenuItem>
                          {[0, 1, 2].map((st, key) => {
                            return (
                              <MenuItem value={st} key={key}>
                                {StatusType(st)}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div className="row2">
                    <div className="child">
                      <FormControl
                        sx={{ margin: 0 }}
                        variant="standard"
                        fullWidth
                      >
                        <TextField
                          id="date"
                          label={i18n.history_filter_created}
                          sx={{ width: "100%" }}
                          type="date"
                          value={createdDate}
                          onChange={handleCreatedDateChange}
                          defaultValue={createdDate}
                          // className={_s(Theme247.inputField)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      </FormControl>
                    </div>

                    <div className="child">
                      <FormControl
                        sx={{ margin: 0 }}
                        variant="standard"
                        fullWidth
                      >
                        <TextField
                          sx={{ width: "100%" }}
                          id="date"
                          label={i18n.history_filter_closed}
                          type="date"
                          value={closedDate}
                          onChange={handleClosedDateChange}
                          defaultValue={closedDate}
                          // className={_s(Theme247.inputField)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className="row3 HT">
                    {/* Hide Export Button */}

                    {canUserPerformAction(
                      props.profile?.features?.export,
                      "create",
                    ) && (
                      <div
                        className="preMailButton child"
                        onClick={handleExportClick}
                      >
                        <div className="icon">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_3182_6442"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="18"
                            >
                              <rect width="18" height="18" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_3182_6442)">
                              <path
                                d="M9 11.6812C8.9 11.6812 8.80625 11.6656 8.71875 11.6344C8.63125 11.6031 8.55 11.55 8.475 11.475L5.775 8.775C5.6375 8.6375 5.56875 8.4625 5.56875 8.25C5.56875 8.0375 5.6375 7.8625 5.775 7.725C5.9125 7.5875 6.09062 7.51562 6.30937 7.50938C6.52813 7.50313 6.70625 7.56875 6.84375 7.70625L8.25 9.1125V3.75C8.25 3.5375 8.32188 3.35938 8.46562 3.21562C8.60938 3.07187 8.7875 3 9 3C9.2125 3 9.39063 3.07187 9.53438 3.21562C9.67813 3.35938 9.75 3.5375 9.75 3.75V9.1125L11.1562 7.70625C11.2937 7.56875 11.4719 7.50313 11.6906 7.50938C11.9094 7.51562 12.0875 7.5875 12.225 7.725C12.3625 7.8625 12.4312 8.0375 12.4312 8.25C12.4312 8.4625 12.3625 8.6375 12.225 8.775L9.525 11.475C9.45 11.55 9.36875 11.6031 9.28125 11.6344C9.19375 11.6656 9.1 11.6812 9 11.6812ZM4.5 15C4.0875 15 3.73438 14.8531 3.44063 14.5594C3.14688 14.2656 3 13.9125 3 13.5V12C3 11.7875 3.07187 11.6094 3.21562 11.4656C3.35938 11.3219 3.5375 11.25 3.75 11.25C3.9625 11.25 4.14062 11.3219 4.28437 11.4656C4.42813 11.6094 4.5 11.7875 4.5 12V13.5H13.5V12C13.5 11.7875 13.5719 11.6094 13.7156 11.4656C13.8594 11.3219 14.0375 11.25 14.25 11.25C14.4625 11.25 14.6406 11.3219 14.7844 11.4656C14.9281 11.6094 15 11.7875 15 12V13.5C15 13.9125 14.8531 14.2656 14.5594 14.5594C14.2656 14.8531 13.9125 15 13.5 15H4.5Z"
                                fill="#0E3F51"
                              />
                            </g>
                          </svg>
                        </div>
                        <div className="text">
                          {i18n.history_filter_actions}
                        </div>
                      </div>
                    )}
                    <div
                      className="preMailButton child"
                      style={{ width: "18%" }}
                      onClick={handleResetFilter}
                      aria-disabled={
                        createdDate === "YYYY-MM-DD" ||
                        closedDate === "YYYY-MM-DD" ||
                        equipment?.hasnotification?.length === 0
                      }
                    >
                      <div className="text">{i18n.history_filter_reset}</div>
                    </div>
                  </div>
                </div>
              </Fade>
            ) : (
              ""
            )}

            <Grid
              item
              xs={7}
              className={myClasses.sectionContentContainer}
              style={{ margin: "0px auto" }}
            >
              {/* <div className={classes.innerSectionContainerWrapper}>
                <div className={cx(classes.innerSectionContainer, classes.nmb)}>
                  <Typography variant="h1">{i18n.heading_life_cycle}</Typography>
                  <div className={myClasses.sectionOptionsButton}>
                    <IconButton onClick={toggleFilter} className="collapsible">
                      <FilterListIcon />
                    </IconButton>
                  </div>
                </div>
                <Typography variant="caption" className={myClasses.tsc}>
                  gesamter Lebenslauf (absteigend) – alle Ereignisse
                </Typography>
              </div> */}

              {/* {isFilter && */}

              {/* } */}

              <section
                className={cx(
                  myClasses.sectionContentContainer,
                  classes.statsContainer,
                )}
              >
                {/*  <StatsNumbers alignment="center" size="large" /> */}
              </section>

              <section className={classes.timelineWrapper}>
                <Typography variant="h2" className={classes.sectionHeading}>
                  {getCurrentYear()}
                </Typography>

                <div className={classes.historyHeaderFirstItem}>
                  <IconText
                    icon={<TodayIcon />}
                    text={i18n.today + ": " + moment().format("DD.MM.YYYY")}
                  />
                </div>

                <div
                  className={clsx(myClasses.itemcardList, classes.itemcardList)}
                >
                  {equipment?.hasnotification?.length > 0 ? (
                    equipment?.hasnotification
                      ?.sort((a, b) =>
                        a.notification.created < b.notification?.created
                          ? 1
                          : -1,
                      )
                      .map((x, key) => {
                        return (
                          <React.Fragment key={key}>
                            {getYearFromTS(x?.notification?.created) ==
                            getCurrentYear() ? (
                              <Link
                                to="/notification-details"
                                state={{
                                  nodeid: x?.notification?.nodeid,
                                  equipmentNodeId: equipment?.nodeid,
                                  from: "history",
                                }}
                                onClick={() => handleNotificationClick(x)}
                              >
                                <NotificationCardItem
                                  showEquipment={false}
                                  data={x}
                                  keywordValue={keywordValue}
                                />
                              </Link>
                            ) : (
                              <div>
                                <div>
                                  {getYearFromTS(x?.notification?.created) !=
                                  adjust_year ? (
                                    ((adjust_year = getYearFromTS(
                                      x?.notification?.created,
                                    )),
                                    (
                                      <>
                                        <Typography
                                          variant="h2"
                                          className={classes.sectionHeading}
                                        >
                                          {getYearFromTS(
                                            x?.notification?.created,
                                          )}
                                        </Typography>
                                        <Link
                                          to="/notification-details"
                                          state={{
                                            nodeid: x.notification.nodeid,
                                            equipmentNodeId: equipment?.nodeid,
                                            from: "history",
                                          }}
                                          onClick={() =>
                                            handleNotificationClick(x)
                                          }
                                        >
                                          <NotificationCardItem
                                            showEquipment={false}
                                            data={x}
                                          />
                                        </Link>
                                      </>
                                    ))
                                  ) : (
                                    <Link
                                      to="/notification-details"
                                      state={{
                                        nodeid: x.notification.nodeid,
                                        equipmentNodeId: equipment?.nodeid,
                                        from: "history",
                                      }}
                                      onClick={() => handleNotificationClick(x)}
                                    >
                                      <NotificationCardItem
                                        showEquipment={false}
                                        data={x}
                                      />
                                    </Link>
                                  )}
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })
                  ) : (
                    <div>
                      <Typography
                        variant="body1"
                        className={classes.emptyStateText}
                      >
                        {i18n.empty_history}
                      </Typography>
                      <p style={{ display: "none" }}>{(adjust_year = "")}</p>
                    </div>
                  )}
                </div>

                <div className={classes.historyFooterLastItem}>
                  <IconText
                    icon={<TodayIcon />}
                    text={
                      i18n.built_year +
                      ": " +
                      moment(+equipment?.constructiondate).format("YYYY")
                    }
                  />
                </div>

                <div className={classes.timelineLineContainer}>
                  <span
                    className={clsx(
                      classes.timelineBubble,
                      classes.timelineBubbleStart,
                    )}
                  />
                  <hr className={classes.timelineLine} />
                  <span
                    className={clsx(
                      classes.timelineBubble,
                      classes.timelineBubbleEnd,
                    )}
                  />
                </div>
              </section>
            </Grid>
          </>
        ) : (
          <EmptyState
            heading={"Maschinenhistorie"}
            title={"Für diese Maschine wurden noch keine Meldungen registriert"}
            description={
              "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind."
            }
            icon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2263_31575"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2263_31575)">
                  <path
                    d="M12 21C9.9 21 8.04167 20.3625 6.425 19.0875C4.80833 17.8125 3.75833 16.1833 3.275 14.2C3.20833 13.95 3.25833 13.7208 3.425 13.5125C3.59167 13.3042 3.81667 13.1833 4.1 13.15C4.36667 13.1167 4.60833 13.1667 4.825 13.3C5.04167 13.4333 5.19167 13.6333 5.275 13.9C5.675 15.4 6.5 16.625 7.75 17.575C9 18.525 10.4167 19 12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 10.05 18.3208 8.39583 16.9625 7.0375C15.6042 5.67917 13.95 5 12 5C10.85 5 9.775 5.26667 8.775 5.8C7.775 6.33333 6.93333 7.06667 6.25 8H8C8.28333 8 8.52083 8.09583 8.7125 8.2875C8.90417 8.47917 9 8.71667 9 9C9 9.28333 8.90417 9.52083 8.7125 9.7125C8.52083 9.90417 8.28333 10 8 10H4C3.71667 10 3.47917 9.90417 3.2875 9.7125C3.09583 9.52083 3 9.28333 3 9V5C3 4.71667 3.09583 4.47917 3.2875 4.2875C3.47917 4.09583 3.71667 4 4 4C4.28333 4 4.52083 4.09583 4.7125 4.2875C4.90417 4.47917 5 4.71667 5 5V6.35C5.85 5.28333 6.8875 4.45833 8.1125 3.875C9.3375 3.29167 10.6333 3 12 3C13.25 3 14.4208 3.2375 15.5125 3.7125C16.6042 4.1875 17.5542 4.82917 18.3625 5.6375C19.1708 6.44583 19.8125 7.39583 20.2875 8.4875C20.7625 9.57917 21 10.75 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21ZM13 11.6L15.5 14.1C15.6833 14.2833 15.775 14.5167 15.775 14.8C15.775 15.0833 15.6833 15.3167 15.5 15.5C15.3167 15.6833 15.0833 15.775 14.8 15.775C14.5167 15.775 14.2833 15.6833 14.1 15.5L11.3 12.7C11.2 12.6 11.125 12.4875 11.075 12.3625C11.025 12.2375 11 12.1083 11 11.975V8C11 7.71667 11.0958 7.47917 11.2875 7.2875C11.4792 7.09583 11.7167 7 12 7C12.2833 7 12.5208 7.09583 12.7125 7.2875C12.9042 7.47917 13 7.71667 13 8V11.6Z"
                    fill="black"
                    fillOpacity="0.5"
                  />
                </g>
              </svg>
            }
          />
        )}
      </div>
    );
  },
);
